module.exports = __webpack_public_path__ + "static/media/registerL.0099e203.jpg";